import * as React from 'react';
import { PersonaSize } from '@fluentui/react/lib/Persona';
import PersonaControl from 'owa-persona/lib/components/PersonaControl';
import {
    useLivePersonaCard,
    PersonaCardBehaviorProps,
} from 'owa-persona/lib/components/PersonaCardBehavior';
import { Icon } from '@fluentui/react/lib/Icon';
import type { ActivityFeedCardDetails } from '../utils/feedCardPresentationDetails';
import { ActivityType } from '../service/ActivityFeedStorageItem';
import { ControlIcons } from 'owa-control-icons';
import styles from './ActivityFeedPersonaControl.scss';
import classnamesBind from 'classnames/bind';
const classNames = classnamesBind.bind(styles);

export interface ActivityFeedPersonaControlProps {
    personas: PersonaCardBehaviorProps[];
    item: ActivityFeedCardDetails;
}
export default function ActivityFeedPersonaControl(
    props: ActivityFeedPersonaControlProps
): JSX.Element {
    const { personas, item } = props;
    const activePersona = useLivePersonaCard(personas.length === 1 ? personas[0] : personas[1]);
    const PersonaCardBehavior = personas.length === 0 ? null : activePersona;
    if (personas.length === 0) {
        return null;
    }
    switch (item.activityType) {
        case ActivityType.TxpFlightReservation:
        case ActivityType.TxpParcelDelivery:
        case ActivityType.RealTimeFlightUpdate:
            return <Icon className={styles.activityTypeIcon} iconName={ControlIcons.OutlookLogo} />;
    }
    if (personas.length === 1) {
        return (
            <PersonaCardBehavior>
                <div className={styles.personaGroup}>
                    <PersonaControl
                        name={personas[0].name}
                        emailAddress={personas[0].emailAddress}
                        size={PersonaSize.size32}
                        mailboxType={''}
                    />
                </div>
            </PersonaCardBehavior>
        );
    } else {
        // 2 or more personas -> show only first 2
        return (
            <PersonaCardBehavior>
                <div className={styles.personaGroup}>
                    <PersonaControl
                        name={personas[0].name}
                        emailAddress={personas[0].emailAddress}
                        size={PersonaSize.size24}
                        className={styles.smallPersona}
                    />
                    <PersonaControl
                        name={personas[1].name}
                        emailAddress={personas[1].emailAddress}
                        size={PersonaSize.size24}
                        className={classNames(styles.smallPersona, styles.bottomPersona)}
                    />
                </div>
            </PersonaCardBehavior>
        );
    }
}
